// ============================================================================
// BOQ — where an uploaded source file lives
// ============================================================================
// Source workbooks and PDFs sit in the private boq-source-files bucket, one
// folder per rate_source_documents row, so a re-upload of the same file
// replaces it in place and two documents never collide on a filename.
// rate_source_documents.storage_path records the object path.
// ============================================================================

import { supabase } from '../../supabaseClient';

export const SOURCE_FILES_BUCKET = 'boq-source-files';

// Storage keys reject some characters the filenames carry (&, commas), so the
// stored name is a safe copy; the document row keeps the real filename.
export const sourceFilePath = (documentId, filename) => {
  const safe = (filename || 'file')
    .normalize('NFKD')
    .replace(/[^\w.\- ]+/g, '_')
    .replace(/\s+/g, ' ')
    .trim();
  return `${documentId}/${safe}`;
};

export const isPdfPath = (path) => /\.pdf$/i.test(path || '');

// A short-lived link for viewing or downloading. Null when it cannot be made.
export async function sourceFileSignedUrl(path, { download = false, seconds = 600 } = {}) {
  if (!path) return null;
  const { data, error } = await supabase.storage
    .from(SOURCE_FILES_BUCKET)
    .createSignedUrl(path, seconds, download ? { download: true } : undefined);
  if (error) {
    console.error('[sourceFileStorage] signed url failed', error);
    return null;
  }
  return data?.signedUrl || null;
}
